import EngineeringDashboardPage from "./page";

export default function EngineeringDashboard() {
  return (
    <div className="flex w-full">
      <EngineeringDashboardPage />
    </div>
  );
}

